import React from 'react';

import styles from './PageHeader.module.scss';

const PageHeader = (props) => {
  const { text } = props;

  return (
    <div className={styles.root__div}>
      <span>{text}</span>
      <div className={styles.separator} />
    </div>
  );
};

export default PageHeader;
